import styled from 'styled-components'

const StyledButton = styled.button`
padding: 1rem 1.5rem;
color: #fff;
background-color: #2C00D5;
border: none;
border-radius: 5px;
cursor: pointer;
box-shadow: 0px 2px 2px rgba(0, 0, 0, .25);
display: block;
font-size: 1rem;
font-weight: 500;

&:hover{
    background-color: #2500B4;
}
`

export default StyledButton

